import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentExpectedCtcValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		if (!control.parent) {
			return null;
		}

		const expectedValue = control.value?.toString().trim();
		const currentValue = control.parent.get('current_ctc')?.value?.toString().trim();

		if (!expectedValue) {
			return null;
		}

		if (!/^\d+(\.\d{1,2})?$/.test(expectedValue)) {
			return { invalidCtc: true };
		}

		const expected = parseFloat(expectedValue);

		if (expected < 0 || expected > 1000) {
			return { ctcOutOfRange: true };
		}

		if (currentValue) {
			const current = parseFloat(currentValue);

			if (expected < current) {
				return {
					expectedLessThanCurrent: true
				};
			}
		}

		return null;
	};
}